export default "__VITE_ASSET__DYe5oteC__"